import type { ChartType, TooltipPositionerFunction } from "chart.js";

export const markedPointTooltipPositioner: TooltipPositionerFunction<ChartType> =
  (items, eventPosition) => {
    const markedPoint = items[0]?.element;
    if (!markedPoint) return eventPosition;
    return { x: markedPoint.x, y: markedPoint.y };
  };
